// extracted by mini-css-extract-plugin
export var layoutDiv = "layout-module--layoutDiv--wgMk8";